export class EmailRequest {
    public name: string;
    public recipient: string;
    public tokens: object;
}
